// extracted by mini-css-extract-plugin
export default {"addToCartControl":"dZ-z","giftCard":"eZ-z","btnContainer":"fZ-z","cartButton":"gZ-z","disabled":"hZ-z"};